import { render, staticRenderFns } from "./probation.vue?vue&type=template&id=b51aea00&scoped=true&"
import script from "./probation.vue?vue&type=script&lang=js&"
export * from "./probation.vue?vue&type=script&lang=js&"
import style0 from "./probation.vue?vue&type=style&index=0&id=b51aea00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51aea00",
  null
  
)

export default component.exports